/**
 * Get theme-based CSS values based on the theme path
 * @example
 * themeGet('fontSize.small') // => `var(--t-fontSize-small)`
 */
function themeGet(path) {
  return "var(--t-" + path.replaceAll('.', '-') + ")";
}
/**
 *
 * @param colorPath The colors path. Example: `'gray.100'`
 * @param opacity Adds opacity to the color. Example: `0.5`
 * @returns The selected color with the added opacity
 */
function themeGetColor(colorPath, opacity) {
  var themePath = "colors." + colorPath;
  if (opacity === undefined) {
    return themeGet(themePath);
  }
  if (process.env.NODE_ENV !== "production") {
    if (opacity < 0 || opacity > 1) {
      // eslint-disable-next-line no-console
      console.warn('The `opacity` in `themeGetColor` function must be a number between 0 and 1');
    }
  }
  return "color-mix(in srgb, " + themeGet(themePath) + ", transparent " + (1 - opacity) * 100 + "%)";
}

export { themeGet, themeGetColor };
